// extracted by mini-css-extract-plugin
export default {"PollEditor":"styles_PollEditor__mxLE7","welcome":"styles_welcome__E64Fr","buttons":"styles_buttons__TEf8b","cancelButton":"styles_cancelButton__lvvzl"};